import React from 'react'

import { LicenseLookupContext } from '../contexts/LicenseLookupContext'
import { fetchLicense } from '../../common/js/license-utility'
import { type ActivationKey } from '../license-lookup.types'
import FulfillmentTable from './FulfillmentTable'
import AkeyDetails from './AkeyDetails'
import Modal, { type ModalHandle } from '../../common/components/Modal'
import SerialLookup from './SerialLookup'
import SpinnerOverlay from '../../common/components/SpinnerOverlay'

import { errorToast } from '../../common/js/toast-utility'

type Props = {
    defaultSerial: string,
    isModal?: boolean
}

export default function LicenseLookup({ defaultSerial, isModal=false }: Props) {
    const [lookupState, setLookupState] = React.useContext(LicenseLookupContext);
    const [modalOpen, setModalOpen] = React.useState(false);
    const [searching, setSearching] = React.useState(false);
    const modalRef = React.useRef<ModalHandle>(null);

    React.useEffect(() => {
        const doQuery = async () => {
            if (defaultSerial == '' || defaultSerial == null) {
                modalRef.current.show();
                setModalOpen(true);
                return;
            }
            await lookupSerial(defaultSerial);
        }

        doQuery();
    }, [defaultSerial])

    const lookupSerial = async (serial: string) => {
        try {
            setSearching(true);
            const akey: ActivationKey = await fetchLicense(serial);
            setLookupState({ ...lookupState, akey: akey, filteredFulfillments: akey.fulfillments });
            setSearching(false);
        }
        catch(err){
            errorToast('License not found');
            modalRef.current.show();
            setModalOpen(true);
        }
    }

    const handleSerialSearch = (serial: string) => {
        modalRef.current.hide();
        setModalOpen(false);
        lookupSerial(serial)
    }

    return (
        <>
        <SpinnerOverlay opaque size={75} hidden={!isModal || (isModal && !searching)} message='Please Wait...'>
            <div className='akey-lookup-container'>
                <div className='akey-lookup-content'>
                    <AkeyDetails akey={lookupState.akey} />
                    <FulfillmentTable fulfillments={lookupState.filteredFulfillments} />
                </div>
            </div>
        </SpinnerOverlay>
        {modalOpen && (
            <div className='akey-lookup-backdrop'></div>
        )}
        {!isModal && (
            <SpinnerOverlay opaque fullscreen message='Please Wait...' size={100} hidden={!searching} />
        )}
        <Modal ref={modalRef} hideCloseButton>
            <SerialLookup onSubmit={handleSerialSearch} />
        </Modal>
        </>
    )
}
